module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-table', {
    attrs: {
      "data": _vm.data
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "id",
            "label": "ID",
            "width": "40",
            "numeric": ""
          },
          scopedSlots: _vm._u([{
            key: "header",
            fn: function(ref) {
              var column = ref.column;

              return [_c('b-tooltip', {
                attrs: {
                  "label": column.label,
                  "dashed": ""
                }
              }, [_vm._v("\n                        " + _vm._s(column.label) + "\n                    ")])]
            }
          }])
        }, [_vm._v(" \n                " + _vm._s(props.row.id) + "\n            ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "user.first_name",
            "label": "First Name"
          },
          scopedSlots: _vm._u([{
            key: "header",
            fn: function(ref) {
              var column = ref.column;

              return [_c('b-tooltip', {
                attrs: {
                  "label": column.label,
                  "dashed": ""
                }
              }, [_vm._v("\n                        " + _vm._s(column.label) + "\n                    ")])]
            }
          }])
        }, [_vm._v("\n                " + _vm._s(props.row.first_name) + "\n            ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "user.last_name",
            "label": "Last Name"
          },
          scopedSlots: _vm._u([{
            key: "header",
            fn: function(ref) {
              var column = ref.column;

              return [_c('b-tooltip', {
                attrs: {
                  "label": column.label,
                  "dashed": ""
                }
              }, [_vm._v("\n                        " + _vm._s(column.label) + "\n                    ")])]
            }
          }])
        }, [_vm._v("\n                " + _vm._s(props.row.last_name) + "\n            ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "date",
            "label": "Date",
            "centered": ""
          }
        }, [_c('span', {
          staticClass: "tag is-success"
        }, [_vm._v("\n                    " + _vm._s(new Date(props.row.date).toLocaleDateString()) + "\n                ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Gender"
          }
        }, [_c('span', [_c('b-icon', {
          attrs: {
            "pack": "fas",
            "icon": props.row.gender === 'Male' ? 'mars' : 'venus'
          }
        }), _vm._v("\n                    " + _vm._s(props.row.gender) + "\n                ")], 1)])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0875d06f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/table/examples/ExCustomHeaders.vue
// module id = 1219
// module chunks = 1 89